module.exports = __webpack_public_path__ + "img/logo.de1be928.png";